import styled from '@emotion/styled';
import NoLogInPageWeb from 'components/layout/NoLogOutPageWeb';
import { useNavigate } from 'react-router-dom';
import { Button } from 'components/ui';

const Elem:React.FC<any> = () => {
  const navigator = useNavigate();

  const handleGotohome = () => {
    navigator('/home')
  };

  return (
    <NoLogInPageWeb disable={false}>
      <Container>
        <Body>
          <TextContainer>
            <SmallText className="special">완료</SmallText>
            <BigText className="Top">인화 구독이 <br/>시작됐어요!</BigText>
            <SmallText className="first">가장 소중한 순간을</SmallText>
            <SmallText>가장 간편한 인화로 평생 간직하세요</SmallText>
          </TextContainer>
          <SquareContainer>
            <SecondContainer>
              <TextWrapper>
                <BigText className="secondType">Basic 플랜</BigText>
              </TextWrapper>
            <TextBox>
              <SmallText className="secondType">사진 원본 파일 평생 보관</SmallText>
              <SmallText className="secondType">프리미엄 용지 인화 5장</SmallText>
              <SmallText className="secondType">프리미엄 전용 앨범 속지 1장</SmallText>
              <SmallText className="secondType">프리미엄 전용 앨범 1장</SmallText>
            </TextBox>
            <ContextWrapper>
              <TextContainerInSquare>매월 25일 결제</TextContainerInSquare>
              <TextContainerInSquare>8,900원</TextContainerInSquare>
            </ContextWrapper>
          </SecondContainer>
        </SquareContainer>
        <ButtonContainer>
          <Button
            layoutVariant="contained"
            variant="default"
            onClick={handleGotohome}
            expand
          >완료</Button>
        </ButtonContainer>
        </Body>
      </Container>
    </NoLogInPageWeb>
  )
}

export default Elem;

const Container = styled.div`
  width: 100%;
  height: 100%;
  min-height: 80vh;
  display: flex;
  flex-direction: column;
  padding: 24px 17px;
`;
const TextContainer = styled.div`
  width: 250px;
  height: 133px;
  display: flex;
  flex-direction: column;
  margin-left: -10px;
`;
const SmallText = styled.div`
  font-family: 'Pretendard';
  font-style: normal;
  font-weight: 300;
  font-size: 16px;

  color: #141414;

  span {
    font-weight: 700;
  }
  &.first {
    margin-top: 6px;
  }
  &.Second {
    margin-top: 12.37px;
  }
  &.title {
    font-weight: 500;
    font-size: 14px;
  }
  &.secondType {
    font-family: 'Pretendard';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 153%;
    color: rgba(137, 137, 137, 1);
  }
  &.special{
    font-size: 13px;
  }
`;
const BigText = styled.div`
  font-family: 'Pretendard';
  font-style: normal;
  font-size: 26px;
  /* line-height: 100%; */
  color: #141414;

  &.Top {
    font-weight: Bold;
    margin-top: 15px;
  }

  &.Bottom {
    font-weight: 300;
  }

  &.secondType {
    font-family: 'Pretendard';
    font-style: normal;
    font-weight: 600;
    font-size: 22px;
    line-height: 100%;
    color: #111111;
  }
`;
const SquareContainer = styled.div`
  max-width: 370px;
  height: 270px;
  background-color: rgba(246, 245, 247, 1);
  margin: 44px auto 0;
  display: flex;
  flex-direction: column;
  /* padding-left: 21px; */
  /* padding-top:32px; */
`;
const TextWrapper = styled.div`
  font-family: 'Pretendard';
  width: 102px;
  height: 23px;
  margin-top: 32px;
`;
const TextBox = styled.div`
  width: 180px;
  height: 80px;
  margin-top: 40px;
`;
const ContextWrapper = styled.div`
  width: 320px;
  height: 42px;
  margin-top: 25px;
  border-top: 1px solid #BCBCBC;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;
const TextContainerInSquare = styled.div`
  margin-top: auto;
  font-family: 'Pretendard';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;

  color: #565656;
`;
const ButtonContainer = styled.div`
  /* width: 300px; */
  width: 100%;
  height: 52px;
  margin: 80px auto 30px;
`;
const Body = styled.div`
  width: 344px;
  margin: 40px auto;
`;
const SecondContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 auto;
`